import React from "react";
import styled from "styled-components";
import SectionsData from "./SectionsData";

export const SectionContainer = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: baseline;
    flex-wrap: wrap;
`;
function ViewPaymentInfo({ data }) {
    return (
        <SectionContainer>
            <SectionsData
                label="Payment Method"
                text={data?.methodType}
            />
            <SectionsData
                label="Bank/ account owner name "
                text={data?.accountHolderName}
            />
            {(data?.methodType === "bank_account" || data?.methodType === "mezza_card") && (
                <SectionsData
                    label="Bank Name"
                    text={data?.bankName || data?.mezzaCardType}
                />
            )}
            {data?.methodType === "bank_account" && (
                <SectionsData
                    label="Bank IBAN"
                    text={data?.bankIban}
                />
            )}
            {data?.methodType === "e_wallet" && (
                <SectionsData
                    label="Wallet Name"
                    text={data?.eWalletType}
                />
            )}
            {data?.methodType === "bank_account" && (
                <SectionsData
                    label="Bank Number"
                    text={data?.bankAccountNumber}
                />
            )}
            {data?.methodType === "mezza_card" && (
                <SectionsData
                    label="Card Number"
                    text={data?.mezzaCardNumber}
                />
            )}
            {data?.methodType === "e_wallet" && (
                <SectionsData
                    label="Wallet Number"
                    text={data?.eWalletNumber}
                />
            )}
        </SectionContainer>
    );
}

export default ViewPaymentInfo;
